export const StickyFooter = () => (
    <footer className="sticky top-[100vh] px-4 py-2 bg-curious-blue-600 text-white text-xs items-center z-[2]">
        <div className="flex space-x-2 divide-x w-fit pr-2">
            <div className="text-center pl-2">v{import.meta.env.FRONTEND_VERSION}</div>
            <div className="text-center pl-2">v{import.meta.env.BACKEND_VERSION}</div>
            {/*<div className="text-center pl-2">v{import.meta.env.SHARED_VERSION}</div>*/}
        </div>
    </footer>            
);
